import { DefaultService } from '../generated-api';
import { InviteEntry } from '../generated-api';

export const getInvites = async (): Promise<InviteEntry[]> => {
  return DefaultService.listInvitesAdminInvitesGet();
};

export const createInvite = async (label?: string, expiresInHours?: number): Promise<InviteEntry> => {
  return DefaultService.createInviteAdminInvitesPost({
    requestBody: { label, expires_in_hours: expiresInHours },
  });
};

export const deleteInvite = async (token: string): Promise<any> => {
  return DefaultService.deleteInviteAdminInvitesTokenDelete({ token });
};
